
import { Component, Vue, Watch } from "vue-property-decorator";
import Api from '@/services/api';

@Component
export default class Captcha extends Vue {
  captchaKey = "";
  captchaUrl = "";
  captchaCode = "";

  mounted() {
    this.getNewCaptcha();
  }

  async getNewCaptcha() {
    try {
      this.$showLoading();

      const response: any = await Api.getCaptcha();

      this.captchaKey = response.headers["captcha-key"] || "";

      if (this.captchaUrl) {
        URL.revokeObjectURL(this.captchaUrl);
      }

      const blob = new Blob([response.data], { type: "image/png" });
      this.captchaUrl = URL.createObjectURL(blob);
      this.captchaCode = "";

      this.emitToParent();
    } catch (error) {
        console.error("Captcha error:", error);
    } finally {
        this.$hideLoading();
    }
  }

  @Watch("captchaCode")
    onCaptchaChanged() {
    this.$emit("captchaChanged", {
        key: this.captchaKey,
        code: this.captchaCode
    });
  }

  emitToParent() {
    this.$emit("captchaChanged", {
      key: this.captchaKey,
      code: this.captchaCode
    });
  }
}
